var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 18H1.5C1.22386 18 1 18.2239 1 18.5V22.5C1 22.7761 1.22386 23 1.5 23H4.5C4.77614 23 5 22.7761 5 22.5V18.5C5 18.2239 4.77614 18 4.5 18Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11H7.5C7.22386 11 7 11.2239 7 11.5V22.5C7 22.7761 7.22386 23 7.5 23H10.5C10.7761 23 11 22.7761 11 22.5V11.5C11 11.2239 10.7761 11 10.5 11Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18H13.5C13.2239 18 13 18.2239 13 18.5V22.5C13 22.7761 13.2239 23 13.5 23H16.5C16.7761 23 17 22.7761 17 22.5V18.5C17 18.2239 16.7761 18 16.5 18Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11H19.5C19.2239 11 19 11.2239 19 11.5V22.5C19 22.7761 19.2239 23 19.5 23H22.5C22.7761 23 23 22.7761 23 22.5V11.5C23 11.2239 22.7761 11 22.5 11Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.293 1.29304L15 7.58604L9.70702 2.29304C9.51949 2.10557 9.26518 2.00025 9.00002 2.00025C8.73486 2.00025 8.48055 2.10557 8.29302 2.29304L1.29302 9.29304C1.19751 9.38529 1.12133 9.49563 1.06892 9.61764C1.01651 9.73964 0.988924 9.87086 0.98777 10.0036C0.986616 10.1364 1.01192 10.2681 1.0622 10.391C1.11248 10.5139 1.18673 10.6255 1.28063 10.7194C1.37452 10.8133 1.48617 10.8876 1.60907 10.9379C1.73196 10.9881 1.86364 11.0134 1.99642 11.0123C2.1292 11.0111 2.26042 10.9836 2.38242 10.9311C2.50443 10.8787 2.61477 10.8026 2.70702 10.707L9.00002 4.41404L14.293 9.70704C14.4805 9.89451 14.7349 9.99983 15 9.99983C15.2652 9.99983 15.5195 9.89451 15.707 9.70704L22.707 2.70704C22.8892 2.51844 22.99 2.26584 22.9877 2.00364C22.9854 1.74144 22.8802 1.49063 22.6948 1.30522C22.5094 1.11981 22.2586 1.01465 21.9964 1.01237C21.7342 1.01009 21.4816 1.11088 21.293 1.29304Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.b6fc30dae190647c09170040dfa51ef9.svg";
export { ForwardRef as ReactComponent };